export const Mask = (props: any) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_4003_32602" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14">
      <path
        d="M11.3334 6.33198L10.3334 7.33198L6.66669 3.66531L7.66669 2.66531C8.16669 2.16531 10 1.33198 11.3334 2.66531C12.6667 3.99865 11.8334 5.83198 11.3334 6.33198Z"
        fill="white"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M13 1L11.3333 2.66667" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M2.66666 7.66797L3.66666 6.66797L7.33332 10.3346L6.33332 11.3346C5.83332 11.8346 3.99999 12.668 2.66666 11.3346C1.33332 10.0013 2.16666 8.16797 2.66666 7.66797Z"
        fill="white"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66667 9.66667L8 8.33333M1 13L2.66667 11.3333M4.33333 7.33333L5.66667 6"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </mask>
    <g mask="url(#mask0_4003_32602)">
      <path d="M-1 -1H15V15H-1V-1Z" fill={props.fill} />
    </g>
  </svg>
);
